<template>
  <div class="landing-wrapper">
    <div class="paper-edge top"></div>
    <div class="landing-content">
      <header>
        <h1>News Bites</h1>
      </header>
      <section class="latest-article">
        <article-level-twenty-two :nid="nid" theme="full"></article-level-twenty-two>
      </section>
      <nav class="landing-tabs" :class="{'show-popular-articles' : popularArticles}">
        <span class="latest" :class="{'active' : !popularArticles}" @click="toggleTabs">Latest</span>
        <span class="popular" :class="{'active' : popularArticles}" @click="toggleTabs">Popular</span>
      </nav>
      <div class="main-content">
        <div class="transition-wrapper" :class="{'show-popular-articles' : popularArticles}">
          <section class="latest-articles fifty-fifty">
            <article-level-twenty-two :nid="latestNid" v-for="(latestNid, index) in nids" :class="[{ 'last-two': index==19 ||
            index==18 }, {'hidden-md-up': (nid === latestNid)}]"></article-level-twenty-two>
          </section>
          <section class="popular-articles fifty-fifty">
            <article-level-twenty-two :nid="item.nid" v-for="(item, index) in filteredPopularArticle" :class="{
              'last-two':
            index==19 ||
             index==18 }"></article-level-twenty-two>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import isEmpty from 'lodash/isEmpty'
  import get from 'lodash/get'
  import remove from 'lodash/remove'
  import cloneDeep from 'lodash/cloneDeep'
  import filter from 'lodash/filter'
  import sortBy from 'lodash/sortBy'
  import slice from 'lodash/slice'
  import forEach from 'lodash/forEach'

  import mounted from 'components/mixins/mounted'
  import { mapGetters, mapState, mapActions } from 'vuex'

  import { fetchAllTechCityShareCount } from 'mixins/social-share-manager'

  export default {
    name: 'landing-page',
    props: {
      nids: {
        type: Array,
        required: true,
      },
    },
    mixins: [mounted],
    components: {
      ArticleLevelTwentyTwo: () => import('components/article-levels/Lv22.vue'),
    },
    data() {
      return {
        titleCollapsed: false,
        scrollableWrapperH: {},
        scrollStop: null,
        numPerSlideScope: 10,
        popularArticles: false,
        items: 20,
        filteredPopularArticle: [],
      }
    },
    created() {
      if (get(this, 'nids[0]') && this.activeNID != get(this, 'nids[0]')) this.setActiveNID(this.nids[0])
    },
    mounted() {
      fetchAllTechCityShareCount().then((res) => {
        this.filteredPopularArticle = slice(sortBy(filter(res, item => get(item, 'nid')), 'count').reverse(), 0, 12)
      }).finally(() => {
        forEach(this.filteredPopularArticle, item => this.$store.dispatch('fetchNode', {nid: item.nid}))
      })
    },
    destroyed() {
      this.$emit('destroyLandingPage')
    },
    computed: {
      ...mapState(['activeNID']),
      shareUrl() {
        return `${this.requestDomain()}${get(this, 'node.relative_url')}`
      },
    },
    methods: {
      isEmpty,
      ...mapGetters(['requestDomain']),
      ...mapActions(['setActiveNID']),
      toggleTabs() {
        this.popularArticles = !this.popularArticles
      },
    },
  }
</script>


<style lang="scss" scoped>
  $landingHorizontalPaddingDesktop: rem-calc(30);
  $landingHorizontalPaddingDesktopNeg: -#{$landingHorizontalPaddingDesktop};
  $landingHorizontalPaddingMobile: rem-calc(20);
  $landingHorizontalPaddingMobileNeg: -#{$landingHorizontalPaddingMobile};

  .landing-wrapper {
    color: $greyish-brown;
    width: 80vw;
    height: 100%;
    position: relative;
    overflow: hidden;
    will-change: transform, opacity;
    margin: 0 auto;
    @include respond-to('mobile') {
      width: 100vw;
    }

    @include respond-to("hd") {
      width: rem-calc(1250px);
    }

    @include respond-to("largedesktop") {
      width: rem-calc(1200px);
    }

    .landing-content {
      padding: rem-calc(0 0 50 0);
      background: $off-white;
      overflow-y: auto;
      height: calc(100vh - 100px);

      @include respond-to("mobile") {
        height: calc(100vh - 67px);
      }
    }

    .paper-edge {
      background-image: url('/static/svg/newspaper-edge-top.svg');
      height: rem-calc(8);
      background-position: 0 0;
      background-repeat: repeat;
    }
  }

  .impression-tracker {
    width: rem-calc(1);
    height: rem-calc(1);
  }

  header {
    position: sticky;
    top: rem-calc(0);
    background: $off-white;
    padding: rem-calc(20 0 16);
    z-index: 10;

    @include respond-to("mobile") {
      padding-bottom: rem-calc(0);
    }
  }

  h1  {
    margin: rem-calc(0 30);
    background: $darker-gray-2;
    color: $undercooked-omelette;
    font-size: rem-calc(20);
    line-height: rem-calc(24);
    text-align: center;
    display: block;
    padding: rem-calc(12 0);
    text-transform: uppercase;
    font-weight: bold;

    @include respond-to("mobile") {
      padding: rem-calc(5 0 7);
      margin: rem-calc(0 5);
    }
  }

  nav {
    margin: rem-calc(10 40 20);
    border-bottom: 1px solid $darker-gray-2;
    padding-top: rem-calc(20);
    position: sticky;
    top: rem-calc(68);
    z-index: 6;
    background: $undercooked-omelette;

    @include respond-to("mobile") {
      margin: rem-calc(0 18 10);
      padding-top: rem-calc(12);
      top: rem-calc(56);
    }

    &:before {
      content: "";
      position: absolute;
      width: rem-calc(180);
      bottom: 0;
      height: rem-calc(4);
      background: $darker-gray-2;
      transition: 300ms transform ease;

      @include respond-to("mobile") {
        width: 50%;
      }
    }

    &.show-popular-articles:before {
      transform: translateX(100%);
    }

    span {
      border-bottom: 4px solid transparent;
      width: rem-calc(180);
      font-size: rem-calc(16);
      text-transform: uppercase;
      display: inline-block;
      text-align: center;
      cursor: pointer;
      padding-bottom: 0;

      @include respond-to("mobile") {
        width: 50%;
        padding-bottom: rem-calc(2);
        line-height: rem-calc(19);
      }

      &.active {
        font-weight: bold;
      }
    }
  }

  section {
    margin: rem-calc(0 40);

    @include respond-to("mobile") {
      margin: rem-calc(0 18);
    }
  }

  .fifty-fifty {
    display: flex;
    flex-flow: wrap;
    flex-direction: row;
    align-content: flex-start;
    .article-level-twenty-two {
      flex: 0 0 100%;
    }
    @include respond-to("desktop") {
      &:not(.popular-articles) .article-level-twenty-two {
        flex: 0 0 50%;

        &:nth-child(even) {
          border-right: 1px solid $light-gray;
          padding-right: rem-calc(20);
        }
        &:nth-child(odd) {
          border-left: 1px solid $light-gray;
          padding-left: rem-calc(20);
        }
      }
      &.popular-articles .article-level-twenty-two {
        flex: 0 0 50%;

        &:nth-child(odd) {
          border-right: 1px solid $light-gray;
          padding-right: rem-calc(20);
        }
        &:nth-child(even) {
          border-left: 1px solid $light-gray;
          padding-left: rem-calc(20);
        }
      }
    }
  }

  @include respond-to("mobile") {
    .latest-article {
      display: none;
    }
  }

  .transition-wrapper {
    display: flex;
    flex-flow: row nowrap;
    transition: 600ms transform ease;

    @include respond-to("mobile") {
      transition: 300ms transform ease;
    }

    &.show-popular-articles {
      transform: translateX(-100%);
    }
    section {
      display: flex;
      flex-shrink: 0;
      flex-basis: 100%;
      margin: 0;
    }
  }

  .main-content {
    margin: rem-calc(0 40);
    overflow: hidden;

    @include respond-to("mobile") {
      margin: rem-calc(0 18);
    }
  }

</style>



// WEBPACK FOOTER //
// components/tech-city/news-view/LandingPage.vue